import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AFFILIATE_PROFILE_ROUTE_NAME = Symbol('admin.affiliates.approved.profile');
export const TRANSLATION_GROUP_AFFILIATE_PROFILE = Symbol('admin.affiliates.approved.profile');

export const AFFILIATE_PROFILE_UPDATE_MUTATION = 'admin.affiliates.approved.profile.update';
export const AFFILIATE_PROFILE_UPDATE_API_URL = 'admin/affiliates/:id';

export const AFFILIATE_PROFILE_RESET_TWO_FACTOR_AUTH_MUTATION = 'admin.affiliates.approved.profile.reset-two-factor-auth';
export const AFFILIATE_PROFILE_RESET_TWO_FACTOR_AUTH_API_URL = 'admin/affiliates/:id/clear_google_secret';

export const AFFILIATE_PROFILE_SUBAFFILIATE_MUTATION = 'admin.affiliates.approved.profile.subaffiliate';
export const AFFILIATE_PROFILE_SUBAFFILIATE_API_URL = 'admin/affiliate_invitations/:id/update_affiliate_invitaion';

export const AFFILIATES_APPROVED_PROFILE_PERMISSIONS = {
  EDIT: new Permission(
    PermissionsList.admin.AFFILIATES_EDIT,
  ),
  INVITATIONS_EDIT: new Permission(
    PermissionsList.admin.AFFILIATEINVITATIONS_EDIT,
  ),
  CLEAR_GOOGLE_SECRET: new Permission(
    PermissionsList.admin.AFFILIATES_CLEAR_GOOGLE_SECRET,
  ),
  PAYMENT_SYSTEMS_SHOW: new Permission(
    PermissionsList.admin.PAYMENTSYSTEMS_SHOW,
  ),
  PAYMENT_SYSTEMS_UPDATE: new Permission(
    PermissionsList.admin.PAYMENTSYSTEMS_UPDATE,
  ),
};
